import { Component, h } from '@stencil/core';

@Component({
  tag: 'ui-cms-contact-channels-footer',
  styleUrl: 'ui-cms-contact-channels-footer.scss',
})
export class UiCmsContactChannelsFooter {
  render() {
    return (
      <div itemScope itemType="http://schema.org/Organization" class="ui-cms-contact-channels-footer-container">
        <slot></slot>
      </div>
    );
  }
}
